import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - Category Slider';

export default function AOClpAdventureCategorySlider() {
  const linkClickEvent = () => {
    $('.js-ao-clp-category-slider__item').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');

      if (!clickedElementLink) return;

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        `Index: ${$clickedElement.index() + 1}`,
      );
    });
  };

  return { initiate: linkClickEvent };
}
